import { useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import logoAchemed from '../../assets/img/logo-achemed.png';
import { CheckCircle } from 'lucide-react';

export default function LGPDAuthorizationForm() {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [name, setName] = useState('');

  const empresa = "ACHEMED";
  const nomeMedico = "NOME DO MÉDICO";
  const dataConsulta = "DD/MM/AAAA";
  const horaConsulta = "HH:MM";

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isAuthorized) {
      alert("Por favor, marque a caixa de autorização para continuar.");
      return;
    }

    setIsSubmitting(true);

    await new Promise((resolve) => setTimeout(resolve, 1000));

    console.log("Autorização enviada com sucesso");
    setIsSubmitted(true);
    setIsSubmitting(false);
  };

  return (
    <div className="vh-100 d-flex flex-column bg-light" style={{ overflowY: 'auto' }}>
      <header style={{ backgroundColor: '#252525' }}>
        <Container className="py-3">
          <img src={logoAchemed} width={225} alt="Logo Achemed" />
        </Container>
      </header>

      <main className="flex-grow-1 d-flex align-items-center justify-content-center p-4">
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} lg={8} xl={7}>
              {isSubmitted ? (
                <Card>
                  <Card.Body className="py-5">
                    <div className="d-flex flex-column align-items-center text-center">
                      <CheckCircle className="text-success mb-4" size={64} />
                      <div className="mb-4">
                        <h2 className="h3 fw-semibold mb-3">Autorização Registrada!</h2>
                        <p className="text-muted mb-3" style={{ maxWidth: '28rem', margin: '0 auto' }}>
                          Agradecemos pela sua confiança. Sua autorização foi registrada com sucesso e seus dados serão tratados
                          com total segurança e conformidade com a LGPD.
                        </p>
                        <p className="fw-medium mt-4">
                          Estamos aqui para proporcionar mais comodidade no seu atendimento.
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              ) : (
                <Card>
                  <Card.Header>
                    <Card.Title className="mb-2">Autorização de Acesso a Dados</Card.Title>
                    <Card.Text className="text-muted mb-0">
                      Solicitação de autorização conforme LGPD
                    </Card.Text>
                  </Card.Header>
                  <Card.Body>
                    <Form onSubmit={handleSubmit}>
                      <div className="mb-4">
                        <p>
                          Olá, somos o <strong>{empresa}</strong>. Prestamos serviço para <strong>{nomeMedico}</strong> para dar
                          mais comodidade nos seus agendamentos de exames e compra de medicamentos.
                        </p>
                        <p>
                          Gostaríamos de pedir sua autorização para termos acesso às suas solicitações de exames e prescrições de
                          medicamentos da sua consulta de <strong>{dataConsulta}</strong> às <strong>{horaConsulta}</strong>.
                        </p>
                        <p className="small text-muted mb-0">
                          (Lei Geral de Proteção de Dados (LGPD) nº 13.709, de 14 de agosto de 2018)
                        </p>
                      </div>

                      <div className='mb-3'>
                        <Form.Group>
                          <Form.Label>Digite aqui seu nome completo</Form.Label>
                          <Form.Control type='text' value={name} onChange={(e) => setName(e.target.value.toUpperCase())} />
                        </Form.Group>
                      </div>

                      <div className="p-3 border rounded bg-light mb-4">
                        <Form.Check
                          type="checkbox"
                          id="authorization"
                          checked={isAuthorized}
                          onChange={(e) => setIsAuthorized(e.target.checked)}
                          label={
                            <span className="small">
                              Autorizo o acesso às minhas solicitações de exames e prescrições de medicamentos para os fins descritos
                              acima, em conformidade com a LGPD.
                            </span>
                          }
                        />
                      </div>

                      <Button
                        type="submit"
                        variant="primary"
                        className="w-100"
                        disabled={!isAuthorized || name.length === 0 || isSubmitting}
                      >
                        {isSubmitting ? "Enviando..." : "Confirmar Autorização"}
                      </Button>
                    </Form>
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>
        </Container>
      </main>

      <footer className="border-top" style={{ backgroundColor: '#252525' }}>
        <Container className="py-4 text-center">
          <p className="small text-muted mb-0">
            Achemed &copy; {new Date().getFullYear()} - Todos os direitos reservados
          </p>
        </Container>
      </footer>
    </div>
  );
}